import { useNavigate } from "react-router-dom";
import { Trophy } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import { useSport } from "../../contexts/SportContext";
import { useFb } from "../../utils/football";

/**
 * LaunchInterstitial — one-time modal on first home render after the FIFA update.
 * Self-gates on dbUser.has_seen_football_launch.
 */
export const LaunchInterstitial = () => {
  const { dbUser, setDbUser } = useAuth();
  const { setSport } = useSport();
  const fb = useFb();
  const navigate = useNavigate();

  if (!dbUser || dbUser.has_seen_football_launch) return null;

  const dismiss = async (goFootball) => {
    try { await fb.put("/users/profile", { has_seen_football_launch: true }); } catch {}
    setDbUser({ ...dbUser, has_seen_football_launch: true });
    setSport(goFootball ? "football" : "cricket");
    navigate("/");
  };

  return (
    <div className="football-theme fixed inset-0 z-[70] grid place-items-center bg-black/70 p-5" data-testid="launch-interstitial">
      <div className="w-full max-w-sm overflow-hidden rounded-2xl border border-border bg-card">
        <div className="wc-hero-gradient px-6 py-8 text-center">
          <Trophy size={40} className="mx-auto text-amber-300" />
          <h2 className="mt-3 text-2xl font-extrabold text-white">APL is now multi-sport</h2>
          <p className="mt-2 text-sm text-white/80">Football World Cup 2026 starts June 11. Build your squad, beat your friends.</p>
        </div>
        <div className="space-y-2 p-5">
          <button
            onClick={() => dismiss(true)}
            className="w-full rounded-xl wc-bg-gold py-3 text-base font-extrabold text-slate-900"
            data-testid="launch-go-football"
          >
            Take me to Football
          </button>
          <button
            onClick={() => dismiss(false)}
            className="w-full rounded-xl bg-secondary py-3 text-base font-bold text-foreground"
            data-testid="launch-stay-cricket"
          >
            Stay in Cricket
          </button>
        </div>
      </div>
    </div>
  );
};

export default LaunchInterstitial;
